export default {
  en: {
    CustomerClosed: {
      title: 'Cancelled orders',
    },
  },
};
